import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Services.css';

const Services = () => {
  const navigate = useNavigate();

  const otherServices = [
    {
      id: 2,
      title: "Generate Legal Documents",
      description: "Create professional legal documents in minutes. From complaints to court notices, our AI helps you draft accurate legal paperwork.",
      icon: "📄",
      features: [
        "Police complaint drafts",
        "Court case documents",
        "Legal notices & petitions"
      ],
      buttonText: "Create Document",
      route: "/draft-create",
      gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
      color: "#f5576c"
    },
    {
      id: 3,
      title: "Share Your Legal Knowledge",
      description: "Help others by sharing your legal expertise. Contribute legal information, answer questions, and build a community of legal awareness.",
      icon: "🤝",
      features: [
        "Share legal insights",
        "Help your community",
        "Build legal awareness"
      ],
      buttonText: "Contribute Now",
      route: "/contribute",
      gradient: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
      color: "#4facfe"
    },
    {
      id: 4,
      title: "Connect with Legal Advisors",
      description: "Find experienced legal professionals near you. Get expert consultation from verified lawyers and legal advisors for your legal matters.",
      icon: "👨‍⚖️",
      features: [
        "Filter by location & specialty",
        "View profiles & experience",
        "Direct contact with advisors"
      ],
      buttonText: "Find Advisors",
      route: "/legal-advisors",
      gradient: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
      color: "#fa709a"
    },
    {
      id: 5,
      title: "AI Document Reader",
      description: "Received a confusing court notice, legal notice, bank notice or police document? Upload it and instantly understand what it means in simple, everyday language.",
      icon: "📄",
      features: [
        "Explains documents in plain language",
        "Shows urgency level & deadlines",
        "Tells you the exact next steps"
      ],
      buttonText: "Read My Document",
      route: "/document-reader",
      gradient: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
      color: "#6366f1"
    }
  ];

  const handleServiceClick = (route) => {
    if (route) {
      navigate(route);
    }
  };

  return (
    <div className="services-page">
      {/* Hero Section with Search - TOP PRIORITY */}
      <div className="services-hero-section">
        {/* Professional law-themed background decorations */}
        <div className="hero-decor" aria-hidden="true">
          <i className="fas fa-gavel decor-icon decor-1"></i>
          <i className="fas fa-balance-scale decor-icon decor-2"></i>
          <i className="fas fa-book-open decor-icon decor-3"></i>
          <i className="fas fa-landmark decor-icon decor-4"></i>
          <i className="fas fa-file-contract decor-icon decor-5"></i>
          <i className="fas fa-shield-alt decor-icon decor-6"></i>
          <i className="fas fa-scroll decor-icon decor-7"></i>
          <i className="fas fa-stamp decor-icon decor-8"></i>
        </div>
        <div className="hero-card">
          <div className="hero-top">
            {/* <span className="hero-pill">
              <span className="hero-pill-dot" />
              AI-Powered Legal Assistant
            </span> */}
            <h1 className="hero-headline">
              Find Your Legal Solution <span className="hero-headline-accent">in Seconds</span>
            </h1>
            <p className="hero-card-subtitle">
              Ask any legal question and get instant, easy-to-understand guidance — tailored to your situation and your language.
            </p>
          </div>

          {/* Search Bar */}
          <div className="hero-search-container" onClick={() => navigate('/search')}>
            <div className="hero-search-bar">
              <span className="search-icon">🔍</span>
              <input
                type="text"
                placeholder="What legal question do you have today?"
                readOnly
                className="hero-search-input"
              />
              <button className="hero-search-btn">
                Search
              </button>
            </div>
          </div>

          <div className="hero-features">
            <span className="hero-feature-tag">✓ 3 Answer Levels</span>
            <span className="hero-feature-tag">✓ Multiple Languages</span>
            <span className="hero-feature-tag">✓ AI-Powered</span>
          </div>
        </div>
      </div>

      {/* Other Services Section - 4 equal services */}
      <div className="other-services-section">
        <div className="section-header">
          <h2 className="section-title">Explore Our Other Services</h2>
          <p className="section-description">
            Everything you need for your legal journey, all in one place
          </p>
        </div>

        <div className="services-grid">
          {otherServices.map((service) => (
            <div key={service.id} className="service-card-modern" style={{ '--card-color': service.color }}>
              <div className="card-header">
                <div className="card-icon-wrapper" style={{ background: service.gradient }}>
                  <span className="card-icon">{service.icon}</span>
                </div>
                <h3 className="card-title">{service.title}</h3>
              </div>
              
              <p className="card-description">{service.description}</p>
              
              <ul className="card-features">
                {service.features.map((feature, index) => (
                  <li key={index}>
                    <span className="feature-dot" style={{ background: service.color }}>•</span>
                    {feature}
                  </li>
                ))}
              </ul>
              
              <button 
                type="button"
                className="card-action-btn"
                style={{ background: service.gradient }}
                onClick={() => handleServiceClick(service.route)}
                onTouchEnd={(e) => {
                  e.preventDefault();
                  handleServiceClick(service.route);
                }}
                aria-label={`Navigate to ${service.title}`}
              >
                {service.buttonText}
                <span className="btn-icon">→</span>
              </button>
            </div>
          ))}
        </div>
      </div>

      {/* Footer CTA */}
      <div className="services-footer-cta">
        <h2>Need Help Getting Started?</h2>
        <p>Our support team is here to guide you every step of the way</p>
        <button className="contact-btn" onClick={() => navigate('/feedback')}>
          Contact Support
        </button>
      </div>
    </div>
  );
};

export default Services;
